<template>
  <div class="no-padding no-margin">
      <Table v-if="route==`/superadmin/tpas`"></Table>
      <AddNewForm v-if="route==`/superadmin/tpas/add-new`"></AddNewForm> 
      <SingleForm v-if="route==`/superadmin/tpas/tpa`"></SingleForm>
      <InviteForm  v-if="route==`/superadmin/tpas/invite-tpa`"></InviteForm>
  </div>
    
</template>
<script>
import Table from './TPAsTable.vue'
import SingleForm from './SingleTPA.vue'
import AddNewForm from './AddTPA.vue'
import InviteForm from './InviteTPA.vue'
// getPath

export default{
  data(){
    return{
        
    }
  },
  created(){
  },
  computed:{
     route(){
        return this.$route.path;
      },
      routeParams(){
        let parsed =''
        if(this.$route.params.name){
          parsed = this.$route.params.name.replace(/ /g, '%20')
        }
        return parsed
      }
  },
  methods:{

  },
  components:{
        SingleForm,
        AddNewForm,
        Table,
        InviteForm
 
  }
}

</script>
